import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import commonStyles from 'styles/common.scss';

const ErrorScreen = (props) => {
    const {errorMessage} = props;

    return (
        <div
            className={
                classnames(
                    commonStyles.flexCenterContent,
                    commonStyles.fullWidthAndHeight
                )
            }
        >
            <p
                className={commonStyles.textCenter}
            >
                {errorMessage}
            </p>
        </div>
    );
};

ErrorScreen.propTypes = {
   errorMessage: PropTypes.string.isRequired,
};
ErrorScreen.defaultProps = {};

export default ErrorScreen;



// WEBPACK FOOTER //
// ./src/components/controls/ErrorScreen/ErrorScreen.jsx